import { Controller } from "react-hook-form";
import { formatCurrency } from "../../../../utils/format";
export default function ManualField({ row, control, FloatingInput, FloatingNumber, CustomSelect, onFieldUpdate }) {
  const { left, mid, right } = row;

//  console.log("ManualField() row:", row);

  return (
    <div className="calc-frm-field">
      {/* Label */}
      <div className="calc-frm-fld form-group clmn-a-width">
        <Controller
          name={left.name}
          control={control}
          defaultValue={left.label}
          render={({ field }) => (
            <FloatingInput {...field} />
          )}
        />
      </div>

      {/* Type */}
      <div className="calc-frm-fld form-group clmn-b-width">
        <Controller
          name={mid.name}
          control={control}
          defaultValue={mid.placeholder}
          render={({ field }) => (
            <CustomSelect
              {...field}
              value={mid.placeholder}
               options={["% Loan", "% Sale Price", "Flat Fee"]}
              onChange={(v) => {
                field.onChange(v);
                onFieldUpdate(left.camelKey, "type", v);
              }}
            />
          )}
        />
      </div>

      {/* Value */}
      <div className="calc-frm-fld form-group clmn-c-width">
        <Controller
          name={right.name}
          control={control}
          defaultValue={right.placeholder}
          render={({ field }) => (
            <FloatingNumber
              {...field}
              value={right.placeholder}
              onBlur={(e) => {
                field.onBlur(e);
                onFieldUpdate(left.camelKey, "value", e.target.value);
              }}
            />
          )}
        />
      </div>

      {/* Total (computed elsewhere) */}
      <div className="calc-frm-fld form-group fld-txt-right clmn-d-width">
        {formatCurrency(row.totalrow.placeholder)}
      </div>
    </div>
  );
}
